import { I18NMessage } from "model/messages"

export const splitNthFirstWords = (
  text: string,
  numberOfNthFirstWords = 1
): [string, string] => {
  if (!text) {
    return ["", ""]
  }
  const splittedWords = text.split(" ")
  if (splittedWords.length <= numberOfNthFirstWords) {
    return [text, ""]
  }
  const firstNthWords = splittedWords.slice(0, numberOfNthFirstWords).join(" ")
  const otherWords = splittedWords.slice(numberOfNthFirstWords).join(" ")
  return [firstNthWords, otherWords]
}

export const encode = <T extends string>(data: Record<T, string>): string => {
  return Object.keys(data)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
    .join("&")
}

export const getQueryParam = (param: string): string | null => {
  if (typeof window !== "undefined") {
    const searchParams = new URLSearchParams(window.location.search)
    return searchParams.get(param)
  }
  return null
}

export const onFormSubmit: <T extends string>(
  values: Record<T, string>,
  formName: string
) => Promise<Response> = async (values, formName) => {
  const headers: RequestInit = {
    method: "POST",
    mode: "no-cors",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  }

  fetch(window.location.pathname, {
    ...headers,
    body: encode({ ...values, "form-name": formName }),
  })

  return fetch(
    "https://desertwarriorchallenge.us8.list-manage.com/subscribe/post?u=bb216b6ede5af7bd4138ba9b2&amp;id=d01f2f690a",
    { ...headers, body: encode(values) }
  )
}

export const requiredValidator: (value: string) => I18NMessage | null = value =>
  value ? null : "REQUIRED"

export const emailValidator: (value: string) => I18NMessage | null = value => {
  const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return emailRegex.test(value?.toLowerCase()) ? null : "INVALID_EMAIL"
}
